const MAX_GOOD_COUNT = 99
const HAPPY_VOUCHER_PAYMENT_CODE = '45'
const HAPPY_VOUCHER_PRODUCT_ONLY_MESSAGE = '바우처 대상 상품만 함께 결제 가능합니다.<br>일반 상품은 별도로 주문해 주세요.'
const HAPPY_VOUCHER_DELIVERY_FEE_MESSAGE = '배송비는 바우처 적용 대상이 아닙니다.<br>일반 결제로 나눠서 결제됩니다.'
const HAPPY_VOUCHER_SUPPLEMENT_MESSAGE = '바우처로 결제 시, 포인트와<br>상품권은 함께 사용하실 수<br>없습니다.'

function createHappyVoucherGokr (orderProducts) {
  const totals = (orderProducts || []).reduce((result, product) => {
    const quantity = Number(product?.spbkQy || 0)
    const unitPrice = Number(product?.sleUtpc || 0)
    result.quantity += quantity
    result.amount += quantity * unitPrice
    return result
  }, { quantity: 0, amount: 0 })

  if (totals.quantity > MAX_GOOD_COUNT) {
    throw new Error('국민행복카드는 물품코드별 최대 99개까지 결제할 수 있습니다.')
  }

  return encodeURIComponent(JSON.stringify([{
    goodCode: '03',
    goodCnt: String(totals.quantity),
    goodAmt: String(totals.amount)
  }]))
}

function addHappyVoucherParameter (paymentRequest, voucherGokr) {
  paymentRequest.voucherGokr = voucherGokr
  return paymentRequest
}

function addHappyVoucherSubmitHook (inicis, voucherGokr) {
  if (!voucherGokr && !inicis.daisoVoucherSubmitBefore) { return }

  inicis.daisoVoucherGokr = voucherGokr
  if (inicis.daisoVoucherSubmitBefore) { return }

  const originalSubmitBefore = inicis.submitBefore
  inicis.daisoVoucherSubmitBefore = originalSubmitBefore
  inicis.submitBefore = function (...args) {
    originalSubmitBefore.apply(this, args)
    const form = this.$formObj?.[0]
    if (!form) { return }

    let input = form.querySelector('input[name="voucherGokr"]')
    if (!this.daisoVoucherGokr) {
      input?.remove()
      return
    }
    if (!input) {
      input = document.createElement('input')
      input.type = 'hidden'
      input.name = 'voucherGokr'
      form.appendChild(input)
    }
    input.value = this.daisoVoucherGokr
  }
}

function getHappyVoucherPaymentNotice ({ pymtCd, vucrPymtPsblYn, dlvcAm }) {
  if (pymtCd !== HAPPY_VOUCHER_PAYMENT_CODE) { return null }
  if (vucrPymtPsblYn !== 'Y') {
    return { blocking: true, message: HAPPY_VOUCHER_PRODUCT_ONLY_MESSAGE }
  }
  if (Number(dlvcAm) > 0) {
    return { blocking: false, message: HAPPY_VOUCHER_DELIVERY_FEE_MESSAGE }
  }
  return null
}

function resetHappyVoucherSupplementPayments (form) {
  form.pntUseAm = 0
  form.pntUseYn = 'N'
  form.acmyUseAm = 0
  form.acmyUseYn = 'N'
  form.gfUseAm = 0
  form.gfUseYn = 'N'
  return form
}

function getHappyVoucherSupplementNotice (pymtCd) {
  return pymtCd === HAPPY_VOUCHER_PAYMENT_CODE ? HAPPY_VOUCHER_SUPPLEMENT_MESSAGE : null
}

function resetHappyVoucherPaymentReuse (form) {
  if (form?.pymtCd === HAPPY_VOUCHER_PAYMENT_CODE) {
    form.pymtUseYn = 'N'
  }
  return form
}

module.exports = {
  HAPPY_VOUCHER_PAYMENT_CODE,
  HAPPY_VOUCHER_PRODUCT_ONLY_MESSAGE,
  HAPPY_VOUCHER_DELIVERY_FEE_MESSAGE,
  HAPPY_VOUCHER_SUPPLEMENT_MESSAGE,
  createHappyVoucherGokr,
  addHappyVoucherParameter,
  addHappyVoucherSubmitHook,
  getHappyVoucherPaymentNotice,
  getHappyVoucherSupplementNotice,
  resetHappyVoucherSupplementPayments,
  resetHappyVoucherPaymentReuse
}
